export const apmSetCustomContext = (context: object): void => {
  if (globalThis.serverSideApmInstance) {
    globalThis.serverSideApmInstance.setCustomContext(context)
  } else if (globalThis.clientSideApmInstance) {
    globalThis.clientSideApmInstance.setCustomContext(context)
  }
}
